import { AlertTriangle } from "lucide-react";
import { useDisclaimer } from "@/components/layout/DisclaimerContext";

export default function ShortWarning({ testId = "short-warning" }) {
  const { open } = useDisclaimer();
  return (
    <div className="flex items-start gap-3 rounded-md border border-[#C59B27]/40 bg-[#C59B27]/10 px-4 py-3 text-sm text-[#5b4610] mb-6" data-testid={testId}>
      <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0 text-[#9A7A1E]" />
      <p>
        Projections are hypothetical and not guaranteed.{" "}
        <button onClick={open} className="underline font-semibold hover:text-[#0F2E23]" data-testid={`${testId}-link`}>See full disclaimer.</button>
      </p>
    </div>
  );
}
